var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"locked"},[_c('div',{staticClass:"locked-box"},[_c('div',{staticClass:"locked-box-logo"}),_c('div',{staticClass:"locked-box-contents"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }